import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const useRestrictedReportsHook = (schoolId) => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/AdminRestrictedReportsMember/${schoolId}`
        );
        setData(response.data?.rows || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    if (!axiosLoading) {
      fetchData();
    }
  }, [axiosLoading]);

  return {
    data,
    loading,
  };
};

export default useRestrictedReportsHook;
